import { newConfig } from '../config';
import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;

export default class PolicyService {
  constructor(client) {
    this.client = client;
  }

  async getPolicies({ companyId }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/policies`
    );
    return response.data;
  }

  async findAll({
    employeeId,
    employeeStatus,
    companyIds,
    insuranceCompanyId,
    status,
    page,
    size
  }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/policies`,
      {
        params: {
          employeeId,
          employeeStatus,
          companyIds,
          insuranceCompanyId,
          status,
          page,
          size
        }
      }
    );
    return response.data;
  }

  async getGroups({ policyId, employeeId, employeeStatus, page, size }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/policies/${policyId}/group-companies`,
      {
        params: {
          employeeId,
          employeeStatus,
          page,
          size
        }
      }
    );
    return response.data;
  }
}
